module.exports = {"pt-BR":{"components":{"paginator":{"first":"Início","prev":"Anterior","next":"Próximo","last":"Fim"}}}}